module.exports = __webpack_public_path__ + "img/wx.1766306608134.png";